// Default back button selector
export const DEFAULT_SELECTOR = '[data-target="back"]';

class BackButton {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add back button properties on.
   * */
  constructor(elementRef) {
    // Initialise attributes
    this.elementRef = elementRef;

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler for the back button.
   *
   * @param {Event} event - click event on the back button.
   * */
  clickHandler(event) {
    event.preventDefault();
    event.stopPropagation();

    window.history.back();
  }

  // private

  /**
   * Set-up the back button.
   *  1) Appropriately binds all necessary event callbacks.
   * */
  _setup() {
    this._addEventListeners();
  }

  /**
   * Adds all the required event listeners.
   * */
  _addEventListeners() {
    this.elementRef.addEventListener('click', this.clickHandler);
  }
}

export default BackButton;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/backButton/index.js